import { FC, ReactElement, useCallback, useEffect, useMemo, useState } from "react";
import { ContentContainer, ContentCount, ContentFlexCenter, ContentHeader, ContentParagraph, ContentProviders, ContentTitle, CookieContentProps } from "./styled";
import Toggle from "./Toggle";
import Provider from "./Provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { CookieCategoryProp, ToggleStatesProps } from "../CookieConsent";
import styled from "styled-components";
import React from "react";

interface SectionContentProps {
    infoProps: CookieCategoryProp;
    aboutProvider: string;
    onToggleChange(key: string): void;
    toggleState: "denied" | "granted";
    settings: {
        expiry: string;
        type: string;
    };
}

const Icon = styled(FontAwesomeIcon)<{ active?: boolean }>`
  transform: rotateZ(${({ active }) => (active ? "180" : 0)}deg);
  transition: 0.25s transform;
`;

const SectionContent: FC<SectionContentProps> = ({ aboutProvider, infoProps, onToggleChange, toggleState, settings }): ReactElement => {
    const [show, setShow] = useState<boolean>(false);

    const calculateContentCount = useMemo(() => {
        let count = 0;
        infoProps.providers.forEach((p) =>
            p.items.forEach((c) => {
                count++;
            })
        );
        return count;
    }, [infoProps.providers]);

    return (
        <ContentContainer>
            <ContentHeader>
                <ContentFlexCenter active={show} onClick={() => setShow(!show)}>
                    <Icon active={show} icon={faChevronDown} />
                    <ContentTitle active={show}>{infoProps.title}</ContentTitle>
                    <ContentCount active={show}>{calculateContentCount}</ContentCount>
                </ContentFlexCenter>
                <Toggle disabled={infoProps.required} active={toggleState === "granted" ? true : false} onChange={() => onToggleChange(infoProps.id)} />
            </ContentHeader>
            <ContentParagraph>{infoProps.description}</ContentParagraph>
            <ContentProviders active={show} count={infoProps.providers.length}>
                {infoProps.providers.map((o, i) => (
                    <Provider
                        key={i}
                        title={o.title}
                        link={o.link}
                        items={o.items.map((c) => ({
                            description: c.description,
                            title: c.title,
                            expiry: {
                                label: settings.expiry,
                                value: c.expiry
                            },
                            type: {
                                label: settings.type,
                                value: c.type
                            }
                        }))}
                        provider={aboutProvider}
                    />
                ))}
            </ContentProviders>
        </ContentContainer>
    );
};

export default SectionContent;
